import React from 'react'
import { useIntl } from 'gatsby-plugin-react-intl'
import { StaticImage } from 'gatsby-plugin-image'
import * as styles from './Outro.module.scss'
import SectionHead from '../section-head/SectionHead'
import Cta from '../cta/Cta'
import SlideAndFade from '../SlideAndFade'

const Outro: React.FC = () => {
  const t = useIntl()

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <SectionHead
          title={t.formatMessage({ id: 'outro.title' })}
          text={t.formatMessage({ id: 'outro.subtitle1' })}
        />

        <Cta
          content={t.formatMessage({ id: 'outro.cta' })}
          className={styles.cta}
        />

        <div className={styles.mascot}>
          <SlideAndFade
            style={{ opacity: 0.01 }}
            direction='right'
            duration={20 / 24 * 1000}
            delay={10 / 24 * 1000}
          >
            <StaticImage
              src='./assets/blobby-welcoming.png'
              alt=''
              width={201}
              height={277}
            />
          </SlideAndFade>
        </div>
      </div>
    </div>
  )
}

export default Outro
